import { render, staticRenderFns } from "./CreateMaterialPopup.vue?vue&type=template&id=3101f51c"
import script from "./CreateMaterialPopup.vue?vue&type=script&lang=js"
export * from "./CreateMaterialPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports